<template>
  <section
    :class="{
      'section-builder-content-card': true,
    }"
  >
    <GeneralTheme
      :theme="configuration"
      :class="{
        'overflow-background': true,
      }"
    >
      <ContentCard
        v-if="contentCard"
        v-bind="contentCard"
        :use-dark-theme="useDarkTheme"
      />
    </GeneralTheme>
  </section>
</template>

<script lang="ts" setup>
import GeneralTheme from '~/components/Molecules/Themes/GeneralTheme.vue';
import ContentCard from './ContentCard.vue';
import type { SectionBuilderContentCard } from '~/sanity/types';

defineProps<SectionBuilderContentCard>();
</script>

<style lang="scss">
.section-builder-content-card h4 {
  line-height: 28px !important;
}
.section-builder-content-card .overflow-background {
  background-position: top !important;
}
@media (max-width: 768px) {
  .section-builder-content-card h4 {
    font-size: 16px !important;
    line-height: 19px !important;
  }
}
.product-page .section-builder-content-card .background-image-wrapper {
  padding-top: 5rem !important;
  @media (min-width: 768px) {
    padding-bottom: 6.25rem;
  }
}
</style>
